module.exports = "/assets/d6950ae30541453fad2b9545e37c64e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/GH.png
// module id = 1405
// module chunks = 0